<template>
  <section class="about__area pt-90 pb-150">
    <div class="container">
      <div class="row">
<!--        <div class="col-lg-4 col-12">-->
<!--          <div class="about__thumb-wrapper">-->
<!--            <div class="about__thumb">-->
<!--              <img src="../../assets/img/about/faq.png" alt="">-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="col-12">
          <div class="about__content pl-10 pr-10 pt-25">
            <div class="section__title-wrapper mb-25">
              <h2 class="section__title" style="font-size: 30px">{{$t('faq.title')}}.</h2>
            </div>
            <div class="about__list mb-35">
              <div class="d-flex justify-content-start align-items-center">
                  <div
                      @click="activeQuestions = 'social'"
                      class="tabStyle"
                      :style="activeQuestions == 'social' ? `background-color:#2b4eff; color: white`:`background-color:#eff2f7; color: #212529`"
                  >
                    {{ $t('faq.social.tabTitle') }}</div>
                  <div
                      @click="activeQuestions = 'reklama'"
                      class="tabStyle"
                      :style="activeQuestions == 'reklama' ? `background-color:#2b4eff; color: white`:`background-color:#eff2f7; color: #212529`"
                  >
                    {{ $t('faq.reklama.tabTitle') }}</div>
                  <div
                      @click="activeQuestions = 'turizm'"
                      class="tabStyle"
                      :style="activeQuestions == 'turizm' ? `background-color:#2b4eff; color: white`:`background-color:#eff2f7; color: #212529`"
                  >
                    {{ $t('faq.turizm.tabTitle') }}</div>
                  <div
                      @click="activeQuestions = 'house'"
                      class="tabStyle"
                      :style="activeQuestions == 'house' ? `background-color:#2b4eff; color: white`:`background-color:#eff2f7; color: #212529`"
                  >
                    {{ $t('faq.house.tabTitle') }}</div>
                </div>
              <br>
              <div v-if="activeQuestions == 'social'">
                <b-row>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen1 = !isOpen1" variant="light" class="quesBtn">{{ $t('faq.social.quiz1') }}</b-button>
                    <b-collapse id="collapse-1" v-model="isOpen1" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.social.ans11') }} <br>

                          {{ $t('faq.social.ans12') }}<br>

                          {{ $t('faq.social.ans13') }}<br>

                          {{ $t('faq.social.ans14') }}<br>

                          {{ $t('faq.social.ans15') }}<br>

                          {{ $t('faq.social.ans16') }}<br>

                          {{ $t('faq.social.ans17') }}<br>

                          {{ $t('faq.social.ans18') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen2 = !isOpen2" variant="light" class="quesBtn">{{ $t('faq.social.quiz2') }}</b-button>
                    <b-collapse id="collapse-2" v-model="isOpen2" class="mt-1">
                      <b-card><p class="card-text px-4 py-4">{{ $t('faq.social.ans21') }}</p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen3 = !isOpen3" variant="light" class="quesBtn">
                      {{ $t('faq.social.quiz3') }}
                    </b-button>
                    <b-collapse id="collapse-3" v-model="isOpen3" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.social.ans31') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen4 = !isOpen4" variant="light" class="quesBtn">
                      {{ $t('faq.social.quiz4') }}
                    </b-button>
                    <b-collapse id="collapse-4" v-model="isOpen4" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.social.ans41') }}
                          <br>
                          {{ $t('faq.social.ans42') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen5 = !isOpen5" variant="light" class="quesBtn">
                      {{ $t('faq.social.quiz5') }}
                    </b-button>
                    <b-collapse id="collapse-5" v-model="isOpen5" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.social.ans51') }}
                          <br>
                          {{ $t('faq.social.ans52') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen6 = !isOpen6" variant="light" class="quesBtn">
                      {{ $t('faq.social.quiz6') }}
                    </b-button>
                    <b-collapse id="collapse-6" v-model="isOpen6" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.social.ans61') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen7 = !isOpen7" variant="light" class="quesBtn">
                      {{ $t('faq.social.quiz7') }}
                    </b-button>
                    <b-collapse id="collapse-7" v-model="isOpen7" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.social.ans71') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                </b-row>
              </div>
              <div v-if="activeQuestions == 'reklama'">
                <b-row>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen8 = !isOpen8" variant="light" class="quesBtn">
                      {{ $t('faq.reklama.quiz1') }}
                    </b-button>
                    <b-collapse id="collapse-8" v-model="isOpen8" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.reklama.ans11') }}<br>

                          {{ $t('faq.reklama.ans12') }}<br>

                          {{ $t('faq.reklama.ans13') }}<br>
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen9 = !isOpen9" variant="light" class="quesBtn">
                      {{ $t('faq.reklama.quiz2') }}
                    </b-button>
                    <b-collapse id="collapse-9" v-model="isOpen9" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.reklama.ans21') }}<br>
                          {{ $t('faq.reklama.ans22') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen10 = !isOpen10" variant="light" class="quesBtn">
                      {{ $t('faq.reklama.quiz3') }}
                    </b-button>
                    <b-collapse id="collapse-10" v-model="isOpen10" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.reklama.ans31') }}<br>
                          {{ $t('faq.reklama.ans32') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen11 = !isOpen11" variant="light" class="quesBtn">
                      {{ $t('faq.reklama.quiz4') }}
                    </b-button>
                    <b-collapse id="collapse-11" v-model="isOpen11" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.reklama.ans41') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen12 = !isOpen12" variant="light" class="quesBtn">
                      {{ $t('faq.reklama.quiz5') }}
                    </b-button>
                    <b-collapse id="collapse-12" v-model="isOpen12" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.reklama.ans51') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen13 = !isOpen13" variant="light" class="quesBtn">
                      {{ $t('faq.reklama.quiz6') }}
                    </b-button>
                    <b-collapse id="collapse-13" v-model="isOpen13" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.reklama.ans61') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                </b-row>
              </div>
              <div v-if="activeQuestions == 'turizm'">
                <b-row>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen14 = !isOpen14" variant="light" class="quesBtn">
                      {{ $t('faq.turizm.quiz1') }}
                    </b-button>
                    <b-collapse id="collapse-14" v-model="isOpen14" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.turizm.ans11') }}<br>
                          {{ $t('faq.turizm.ans12') }}<br>
                          {{ $t('faq.turizm.ans13') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen15 = !isOpen15" variant="light" class="quesBtn">
                      {{ $t('faq.turizm.quiz2') }}
                    </b-button>
                    <b-collapse id="collapse-15" v-model="isOpen15" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.turizm.ans21') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen16 = !isOpen16" variant="light" class="quesBtn">
                      {{ $t('faq.turizm.quiz3') }}
                    </b-button>
                    <b-collapse id="collapse-19" v-model="isOpen16" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.turizm.ans31') }}<br>
                          {{ $t('faq.turizm.ans32') }}<br>
                          {{ $t('faq.turizm.ans33') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen17 = !isOpen17" variant="light" class="quesBtn">
                      {{ $t('faq.turizm.quiz4') }}
                    </b-button>
                    <b-collapse id="collapse-16" v-model="isOpen17" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.turizm.ans41') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen18 = !isOpen18" variant="light" class="quesBtn">
                      {{ $t('faq.turizm.quiz5') }}
                    </b-button>
                    <b-collapse id="collapse-17" v-model="isOpen18" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.turizm.ans51') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen19 = !isOpen19" variant="light" class="quesBtn">
                      {{ $t('faq.turizm.quiz6') }}
                    </b-button>
                    <b-collapse id="collapse-18" v-model="isOpen19" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.turizm.ans61') }}<br>
                          {{ $t('faq.turizm.ans62') }}<br>
                          {{ $t('faq.turizm.ans63') }}<br>
                          {{ $t('faq.turizm.ans64') }}<br>
                          {{ $t('faq.turizm.ans65') }}<br>
                          {{ $t('faq.turizm.ans66') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                </b-row>
              </div>
              <div v-if="activeQuestions == 'house'">
                <b-row>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen20 = !isOpen20" variant="light" class="quesBtn">
                      {{ $t('faq.house.quiz1') }}
                    </b-button>
                    <b-collapse id="collapse-20" v-model="isOpen20" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.house.ans11') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen21 = !isOpen21" variant="light" class="quesBtn">
                      {{ $t('faq.house.quiz2') }}
                    </b-button>
                    <b-collapse id="collapse-21" v-model="isOpen21" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.house.ans21') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen22 = !isOpen22" variant="light" class="quesBtn">
                      {{ $t('faq.house.quiz3') }}
                    </b-button>
                    <b-collapse id="collapse-22" v-model="isOpen22" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.house.ans31') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen23 = !isOpen23" variant="light" class="quesBtn">
                      {{ $t('faq.house.quiz4') }}
                    </b-button>
                    <b-collapse id="collapse-23" v-model="isOpen23" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.house.ans41') }}<br>
                          {{ $t('faq.house.ans42') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen24 = !isOpen24" variant="light" class="quesBtn">
                      {{ $t('faq.house.quiz5') }}
                    </b-button>
                    <b-collapse id="collapse-24" v-model="isOpen24" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.house.ans51') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col cols="12" class="mb-1">
                    <b-button @click="isOpen25 = !isOpen25" variant="light" class="quesBtn">
                      {{ $t('faq.house.quiz6') }}
                    </b-button>
                    <b-collapse id="collapse-25" v-model="isOpen25" class="mt-1">
                      <b-card>
                        <p class="card-text px-4 py-4">
                          {{ $t('faq.house.ans61') }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name:'faqArea',
  data() {
    return {
      activeQuestions: 'social',
      isOpen1: false,
      isOpen2: false,
      isOpen3: false,
      isOpen4: false,
      isOpen5: false,
      isOpen6: false,
      isOpen7: false,
      isOpen8: false,
      isOpen9: false,
      isOpen10: false,
      isOpen11: false,
      isOpen12: false,
      isOpen13: false,
      isOpen14: false,
      isOpen15: false,
      isOpen16: false,
      isOpen17: false,
      isOpen18: false,
      isOpen19: false,
      isOpen20: false,
      isOpen21: false,
      isOpen22: false,
      isOpen23: false,
      isOpen24: false,
      isOpen25: false,


    }
  }
};
</script>
<style lang="scss" scoped>
.tabStyle{
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 3px;
}
.quesBtn{
  width: 100%;
  text-align: start;
  border: none;
  padding:15px 20px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown button {
  background-color: #4CAF50;
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.dropdown-content ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.dropdown-content li {
  padding: 10px;
}
.dropdown:hover .dropdown-content {
  display: block;
}

.sumStyle{
  font-size: 8px;
}
.siteColor{
  color: #006080;
  font-weight: bold;
}
::v-deep .base-form-component__label{
  color: #006080;
  margin-bottom: 10px;
  font-size: 14px;
}


::v-deep .custom-select{
  width: 90%;
  border: 1px solid #006080;
}

::v-deep .custom-select option{
  color: #006080;
  font-size: 14px;
}
::v-deep .custom-select option:hover{
  background-color: #006080 !important;
  color: white;

}
::v-deep .VueCarousel-navigation-button::before {
  content: "";
  position: absolute;
  top: 0px;
  height: 35px;
  width: 35px;
}

ul,
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: inherit;
}

/* === util styles === */
.v-hidden {
  position: absolute;
  white-space: nowrap;
  width: 1px;
  height: 1px;
  overflow: hidden;
  border: 0;
  padding: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  margin: -1px;
}
/* === aside styles === */
.aside {
  display: flex;
  width: 100%;
}

/* === list styles === */
.list {
  width: 90%;
  padding-left: 0px;
  font-size: 15px;
  color: #111;

  &-item {
    width: 100%;
    cursor: pointer;
    border: 1px solid #006080;
    border-radius: 5px;
    padding:0px 8px;

    &:first-child {
    }
    &:last-child {
      border-bottom: 1px solid #006080;
    }
  }
}

/* === drop styles === */
.drop {

  padding: 6px 0;
  line-height: 1.5;
  white-space: nowrap;
  transition: color 0.2s;


  &:hover {
    font-weight: bold;
    color: white;
  }
  &.show::after {
    transform: rotate(180deg);
  }
  &list {
    font-size: 0.9em;
    width: 100%;
    /** max-height: 200px; **/
    transition: max-height 0.2s ease-out;
    overflow: hidden;

    li {
      padding: 5px 3px 5px 10px;
      transition: background-color 0.2s ease-out;
    }
    li:hover {

      /** background-color: rgba(43, 103, 91, 0.2);**/
    }
  }
}

</style>
